import { AccountingTable } from './AccountingTable';

export default AccountingTable;
